import { IonList } from "@ionic/react";
import { useContext, useEffect, useState } from "react";
import ThemeSelector from "../../components/ThemeSelector";
import Languages from "../../components/Languages";
import RowSelector from "../../components/ShowQueryDataResult";
import { getUserHasAccess } from "../../util/UserHelper";
import { TranslationsContext } from "../../util/Translations";
import {
  ReadOnlyNote,
  SettingsSubPage,
  useEamSettingsReadOnly,
} from "./settingsShared";

const GeneralSettings: React.FC = () => {
  const { translations } = useContext(TranslationsContext);
  const readOnly = useEamSettingsReadOnly();
  const [languagesAccess, setLanguagesAccess] = useState(false);

  useEffect(() => {
    getUserHasAccess("w_setup_user", "Change Language").then(setLanguagesAccess);
  }, []);

  return (
    <SettingsSubPage title={translations["lbl_mob_settings_general"] || "General"}>
      {readOnly && <ReadOnlyNote />}
      <div className="settings-section-title">
        {translations["lbl_mob_settings_themes"] || "Themes"}
      </div>
      <IonList inset className="settings-list">
        <ThemeSelector />
      </IonList>
      <div className="settings-section-title">
        {translations["lbl_mob_settings_language_results"] || "Language and results"}
      </div>
      <IonList inset className="settings-list">
        {languagesAccess && <Languages disabled={readOnly} />}
        <RowSelector disabled={readOnly} />
      </IonList>
    </SettingsSubPage>
  );
};

export default GeneralSettings;
